import React, { Component } from 'react'
import R from 'ramda'
import {
  Button,
  Modal,
  TextInput,
  SelectSearch,
} from 'advenio-components'
import PropTypes from 'prop-types'
import Slider from 'rc-slider'
import styled from 'styled-components'
import { Form } from 'formsy-react-2'
import 'rc-slider/assets/index.css'
import {
  HeaderTitle,
  Close,
  Save,
  SwitchDiv,
  Span,
  Img,
  HeaderSpan,
  Content,
  TemperatureContainer,
  TemperatureDiv,
  TemperatureText,
  TemperatureNumber,
  TemperatureSlider,
  SliderDiv,
  QuestionsTeacherContainer,
  QuestionsDiv,
  DivAskTeacher,
  SwitchTeacherContainer,
  Check,
  SelectContainer,

} from './ModalAssessment.styles'
// import { HIGH_TEMPERATURE } from '../../Constants'
import { parseFullName } from '../../utils/Utils'

const CheckContainer = styled.div`
  height: 50px;
  width: 98%;
  position: relative;
  overflow: hidden;
  display: flex;
  cursor: pointer;
  background-color: ${props => (props.selected ? '#4A90E2' : '')};
  margin-bottom: 5px;
  margin-top: 5px;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  border-radius: 5px;
  border: solid 1px #cccccc;
`

const Buttons = styled.button`
  color: ${props => (props.selected ? '#FFF' : '')};
  background-color: transparent;
  height: 100%;
  width: 100%;
  cursor: pointer;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  border: solid 0.5px transparent;
`
const Input = styled.input`
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  height: 100%;
  width: 100%;
  cursor: pointer;
`
const HR = styled.span`
  font-weight:bold;
`
const Title = styled.div`
  width: 100%;
  margin-bottom: 9px
`

const initialState = {
  close: false,
  color: '#75B753',
  temperature: 35,
  extra: [],
  revise: [],
  askEmployee: [],
  classrooms: [],
  room: '#75B753',
  goTo: 'Enviar Valoración',
  goToMovil: 'Enviar Valoración',
  icon: '/assets/checkRoom.svg',
  isParentPresent: true,
  showParentQuestion: false,
  formatEmployees:[]
}

class modalHealthTeacher extends Component {
  constructor(props) {
    super(props)
    this.state = {
      close: false,
      width: 0,
      color: '#75B753',
      temperature: 35,
      extra: [],
      revise: [],
      askTeacher: [],
      extraAksTeacher:[],
      classrooms: [],
      room: '#75B753',
      goTo: 'Enviar Valoración',
      goToMovil: 'Enviar Valoración',
      icon: '/assets/checkRoom.svg',
      isParentPresent: true,
      showParentQuestion: false,
      formatTeacher:[]
    }
  }

  componentDidMount() {
    this.updateWindowDimensions()
    window.addEventListener('resize', this.updateWindowDimensions)
  }

  componentWillReceiveProps(nextProps) {
    const { questions , employees } = this.props
    const askTeacher =R.clone(questions).filter( q => q.input_type !== null,questions)
    const extraAksTeacher = R.clone(questions).filter( q => q.input_type === null,questions)
    const formatTeacher = []//this.renderOptionsEmployees(employees)

    setTimeout(() => {
      if (this.scrollArea) {
        this.scrollArea.scrollTop = 1
        this.scrollArea.addEventListener('scroll', this.preventIOSScroll)
      }
    }, 250)

    if (extraAksTeacher) {
      for (let i = 0; i < extraAksTeacher.length; i++) {
        extraAksTeacher[i].selected = false
        extraAksTeacher[i].details = ''
      }
    }

    if (askTeacher) {
      for (let i = 0; i < askTeacher.length; i++) {
        askTeacher[i].selected = false
      }
    }

    this.setState({ askTeacher, formatTeacher, extraAksTeacher })
  }


  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions)
    if (this.scrollArea) {
      this.scrollArea.removeEventListener('scroll', this.preventIOSScroll)
    }
  }

  onChange = index => (e) => {
    const newState = { ...this.state }
    for (let i = 0; i < newState.extraAksTeacher.length; i++) {
      if (i == index) {
        newState.extraAksTeacher[i].selected = true
        newState.extraAksTeacher[i].details = e.target.value
      }
    }
    this.setState(newState, this.goTo)
  }

  getExtraQuestions = () => {
    const { extraAksTeacher } = this.state

    if (!extraAksTeacher) {
      return null
    }

   return extraAksTeacher.map((question, index) => (
      <SwitchDiv key={question.id}>
        <TextInput
          style={{width:'80%'}}
          textarea
          name={`question-${question.id}`}
          label={question.question}
          onChangeCallback={this.onChange(index)}
          hideEmptyHelpBlock
        />
      </SwitchDiv>
    ))
  }

  getAskEmployeeQuestions = () => {
    const { askTeacher } = this.state
    return askTeacher
      ? askTeacher.filter(q =>q.input_type !== null).map((employeeQuestion, index, array) =>
          //eslint-disable-line
        (
          <CheckContainer key={employeeQuestion.id} selected={employeeQuestion.selected}>
            <Input
              onClick={() => this.clickAskEmployee(index)}
              id={employeeQuestion.id}
              type="radio"
            />
            <Buttons
              onClick={() => this.clickAskEmployee(index)}
              selected={employeeQuestion.selected}
              type="button"
            >
              <Check
                src={
                    employeeQuestion.selected
                    ? '/assets/check_mark.svg'
                    : '/assets/blank_check_mark.svg'
                }
              />
              {employeeQuestion.question}
            </Buttons>
          </CheckContainer>
        ),
      )
      : null
  }

  preventIOSScroll = (e) => {
    const elem = e.currentTarget
    const top = elem.scrollTop
    const totalScroll = elem.scrollHeight
    const currentScroll = top + elem.offsetHeight

    if (top === 0) {
      elem.scrollTop = 1
    } else if (currentScroll === totalScroll) {
      elem.scrollTop = top - 1
    }
  }

  changeColor = () => {
    let count = 0

    if (this.state.temperature >= 38 ) {
      this.setState({
        color: '#C50315',
        room: '#C50315',
        goTo: 'Enviar Valoración',
        goToMovil: 'Enviar Valoración',
        icon: '/assets/Warning.svg',
      })
    } else if (count === 0 && this.state.goTo !== 'Mandar a Casa') {
      this.setState({
        color: '#75B753',
        room: '#75B753',
        goTo: 'Enviar Valoración',
        goToMovil: 'Enviar Valoración',
        icon: '/assets/checkRoom.svg',
      })
    }

  }

  clickAskEmployee = (index) => {
    const newState = { ...this.state }
    newState.askTeacher[index].selected = !newState.askTeacher[index].selected
    this.setState(newState)
  }

  handleChange = (temperature) => {
    const realValue = temperature / 10
    this.setState({ temperature: realValue }, () => this.changeColor())
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth })
  }

  closeModal = () => {
    this.props.closeAssessment()
    this.setState(initialState)
  }

  send = (data) => {
    const infoToSend = []
    let params = ''
    for (let i = 0; i < this.state.extraAksTeacher.length; i++) {
      if (this.state.extraAksTeacher[i].selected) {
        infoToSend.push({
          question_id: this.state.extraAksTeacher[i].id,
          details: this.state.extraAksTeacher[i].details,
        })
      }
    }

    for (let i = 0; i < this.state.askTeacher.length; i++) {
      if (this.state.askTeacher[i].selected) {
        infoToSend.push({ question_id:this.state.askTeacher[i].id })
      }
    }

    params = {
      temperature: this.state.temperature,
      observations: infoToSend,
    }

    this.props.postHelathTeacher(this.props.teacher, params)
    this.closeModal()
  
  }

renderOptionsEmployees = employess => employess.filter(e => e.deleted_at === undefined &&  e.department.abbreviation !== null ).map(e => ({ id: e.id, label: parseFullName(e), value: e.id}))

  render() {
    return (
      <Modal
        isOpened={this.props.open}
        full={this.state.width < 763}
        onClose={this.closeModal}
      >
         <Form onSubmit={this.send}>
          <HeaderTitle room={this.state.room}>
            <Close>
              <Img src="/assets/closeAssessment.svg" onClick={this.closeModal} />
            </Close>
            <HeaderSpan>
              <img src={this.state.icon} style={{ paddingRight: '5px' }} />
              <span>Valoración Diaria Formadora</span>
            </HeaderSpan>
            <Save>
              <Button
                small
                style={this.state.width < 763 ? { fontSize: '9px'} : {fontSize: '14.5px'}}
                primary
                type="submit"
                loading={this.props.loading}
              >
                {this.state.width < 763 ? this.state.goToMovil : this.state.goTo}
              </Button>
            </Save>
          </HeaderTitle>
        <Content
            innerRef={(el) => {
              this.scrollArea = el
            }}
          >
            {/* <SelectContainer>
                <SelectSearch
                required
                name="employee_id"
                label="Empleado"
                options={this.state.formatEmployees}
                placeholder="Selecciona un empleado"
                />
            </SelectContainer>  */}
            <TemperatureContainer>
              <TemperatureDiv>
                <TemperatureText>
                  <Span>TEMPERATURA</Span>
                  <TemperatureNumber>{`${this.state.temperature} ºC`}</TemperatureNumber>
                </TemperatureText>
                <TemperatureSlider>
                  <SliderDiv>
                    <Slider
                      allowCross={false}
                      min={350}
                      max={420}
                      count={1}
                      onChange={value => this.handleChange(value)}
                      trackStyle={[{ backgroundColor: this.state.color }]}
                      handleStyle={[
                        {
                          backgroundColor: '#FFFFFF',
                          border: '#FFFFFF',
                          height: '25px',
                          width: '25px',
                          marginTop: '-10px',
                        },
                      ]}
                      railStyle={{ backgroundColor: '#CCCCCC' }}
                    />
                  </SliderDiv>
                </TemperatureSlider>
              </TemperatureDiv>
            </TemperatureContainer>
            <Title>
               <span style={{marginLeft:'30px'}}>Preguntar</span>
            </Title>
            <QuestionsTeacherContainer>
              <QuestionsDiv>
                <DivAskTeacher>
                  {this.getAskEmployeeQuestions()}
                </DivAskTeacher>
              </QuestionsDiv>
            </QuestionsTeacherContainer>
            <SwitchTeacherContainer>{this.getExtraQuestions()}</SwitchTeacherContainer>
          </Content>
        </Form> 
      </Modal>
    )
  }
}

modalHealthTeacher.propTypes = {
  closeAssessment: PropTypes.func,
  postChildHealthCheck: PropTypes.func,
  postChildVirtualHealthCheck: PropTypes.func,
  child: PropTypes.object,
}
modalHealthTeacher.defaultProps = {
  closeAssessment: () => {},
  postChildHealthCheck: () => {},
  postChildVirtualHealthCheck: () => {},
  child: {},
}

export default modalHealthTeacher



// WEBPACK FOOTER //
// ./src/Components/ModalContainer/ModalHealthTeacher.jsx